import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.667 2.915a3.124 3.124 0 1 1-.229 4.162L8.163 9.28a3.1 3.1 0 0 1 0 1.442l4.275 2.202a3.12 3.12 0 0 1 2.438-1.17 3.124 3.124 0 1 1-3.04 2.403l-4.274-2.203a3.124 3.124 0 1 1 0-3.907l4.275-2.202a3.13 3.13 0 0 1 .83-2.93m.654 3.016a1 1 0 0 0-.046-.094 1.751 1.751 0 1 1 .046.094M6.679 9.193a1.752 1.752 0 1 0 .03.065zm6.596 4.97a1.751 1.751 0 1 0 .046-.094 1 1 0 0 1-.046.094",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }